import Range from "./Range.js";

export default class DetectedPeakJson {
    #startMinutes;
    #rtMinutes;
    #endMinutes;
    #base;
    #area;
    #areaPerc;
    #startIndex;
    #rtIndex;
    #endIndex;
    #participatesInChromAreaCalculation;


    /**
     * @param {number} startMinutes
     * @param {number} rtMinutes
     * @param {number} endMinutes
     * @param {number} base
     * @param {number} area
     * @param {number} areaPerc
     * @param {number} startIndex
     * @param {number} rtIndex
     * @param {number} endIndex
     * @param {boolean} participatesInChromAreaCalculation
     */
    constructor(startMinutes, rtMinutes, endMinutes, base, area, areaPerc,
                startIndex, rtIndex, endIndex, participatesInChromAreaCalculation) {
        this.#rtMinutes = rtMinutes;
        this.#startMinutes = startMinutes;
        this.#endMinutes = endMinutes;
        this.#base = base;
        this.#area = area;
        this.#areaPerc = areaPerc;
        this.#rtIndex = rtIndex;
        this.#startIndex = startIndex;
        this.#endIndex = endIndex;
        this.#participatesInChromAreaCalculation = participatesInChromAreaCalculation;
    }

    /** @return {number} */
    get startMinutes() {
        return this.#startMinutes;
    }

    /** @return {number} */
    get endMinutes() {
        return this.#endMinutes;
    }

    /** @return {number} */
    get rtMinutes() {
        return this.#rtMinutes;
    }

    /** @return {number|null} */
    get base() {
        return this.#base === 0 ? null : this.#base;
    }

    /** @return {number} */
    get area() {
        return this.#area;
    }

    /** @return {number} */
    get areaPerc() {
        return this.#areaPerc;
    }

    /** @return {Range} */
    get indexRange() {
        return new Range(this.#startIndex, this.#endIndex);
    }

    /** @return {boolean} */
    get participatesInChromAreaCalculation() {
        return this.#participatesInChromAreaCalculation;
    }

    /**
     * @param {DetectedPeakJson} other
     * @return {boolean}
     */
    equals(other) {
        return other instanceof DetectedPeakJson && this.rtMinutes === other.rtMinutes;
    }

    /** @return {DetectedPeakJson[]} */
    static parseManyFromServerBytes(base64String) {
        if (typeof base64String !== "string" || base64String.length === 0) {
            return [];
        }
        const data = new DataView(Int8Array.from(atob(base64String), c => c.charCodeAt(0)).buffer)
        const peaks = [];
        const ver = data.getInt8(0);
        if (ver !== 0)
            throw new Error(`Can't read detected peaks, version is not supported: ${ver}`);
        const end = data.byteLength;
        const step = 40;
        for (let i = 1; i < end; i += step) {
            peaks.push(new DetectedPeakJson(
                +data.getFloat32(i).toFixed(6),
                +data.getFloat32(i + 4).toFixed(6),
                +data.getFloat32(i + 8).toFixed(6),
                +data.getFloat32(i + 12).toFixed(6),
                +data.getFloat32(i + 16).toFixed(6),
                +data.getFloat32(i + 20).toFixed(6),
                +data.getInt32(i + 24),
                +data.getInt32(i + 28),
                +data.getInt32(i + 32),
                +data.getInt32(i + 36) === 1
            ));
        }
        return peaks;
    }
}